import { FC } from 'react';
import { Field, FieldProps, FormikProps } from 'formik';
import { FieldControl } from 'src/UI';
import { DateBox } from 'src/Controls';
import DateFormater from 'src/Utils/DateFormater';

interface IDateTimeFieldProps {
	name: string;
	title: string;

	setData?: Function;
	isRequired?: boolean;
	disabled?: boolean;

	withTime?: boolean;
	needParse?: boolean;

	minDate?: Date;
	maxDate?: Date | 'today';
}

/**
 * Текстовое поле
 */
const DateTimeField: FC<IDateTimeFieldProps> = (props) => {
	const {
		name,
		title,
		setData,
		isRequired = false,
		disabled = false,
		needParse = false,
	} = props;

	const onSetValue = (form: FormikProps<any>, value: Date | null) => {
		let val: any = value;
		if (needParse) {
			val = DateFormater.toShortString(value);
		}
		form.setFieldTouched(name, true);
		form.setFieldValue(name, val);
		!!setData &&
			setData((data: any) => {
				return { ...data, [name]: val };
			});
	};

	/** Возвращает строкое представление значения */
	const getDateValue = (value: Date | string, needParse = false): string => {
		if (typeof value === 'object' && !!value?.getTime) {
			return DateFormater.toShortString(value);
		} else if (!needParse && !!value) {
			const date = new Date(value);
			return DateFormater.toShortString(date);
		}
		return value?.toString() || '';
	};

	/** Преобразует обозначение текущего дня в границу календаря */
	const getDateBound = (value?: Date | 'today'): Date | undefined => {
		if (!value) {
			return undefined;
		}
		if (value === 'today') {
			const tmp = new Date(Date.now());
			return new Date(
				tmp.getFullYear(),
				tmp.getMonth(),
				tmp.getDate(),
				0,
				0,
				0,
				0,
			);
		}
		return value;
	};

	const renderInnerField = ({ form, meta, field }: FieldProps) => {
		const value = getDateValue(field.value, needParse);
		return (
			<FieldControl
				name={name}
				isRequired={isRequired}
				title={title}
				errorMsg={meta.error}
				isInvalid={!!meta.error}
				isTouched={meta.touched}
			>
				<DateBox
					name={name}
					variant="blueControl"
					disabled={disabled}
					onBlur={field.onBlur}
					value={value}
					setValue={(v) => {
						return onSetValue(form, v);
					}}
					minDate={getDateBound(props.minDate)}
					maxDate={getDateBound(props.maxDate)}
					isError={!!meta.error && meta.touched}
				/>
			</FieldControl>
		);
	};

	return (
		<Field id={name} name={name}>
			{renderInnerField}
		</Field>
	);
};

export default DateTimeField;
